import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { HeatwaveDataService } from '../../side-bar/heat-watch/heatwave/heatwave-data.service';
import * as uuid from 'uuid';
import * as L from 'leaflet';
import { UtilsService } from 'src/app/utils/utils.service';


@Component({
  selector: 'app-geo-search',
  templateUrl: './geo-search.component.html',
  styleUrls: ['./geo-search.component.scss']
})
export class GeoSearchComponent implements OnInit {
  marker: any;
  constructor(private utilsService: UtilsService, private router: Router) { }

  @Input() placeholder: string = 'Search location';
  @Input() gisMapComp: any
  @Output() locationSelected = new EventEmitter<any>();
  @Output() searchCleared = new EventEmitter<void>();

  searchControl = new FormControl('');
  suggestions: any[] = [];
  searchSubject = new Subject<string>();
  sessionToken: string | null = null;

  get isDrySpellModule(): boolean {
    return this.router.url.startsWith('/dryspell/');
  }

  ngOnInit(): void {
    this.searchSubject
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.callAutocompleteAPI(value);
      });
    if (this.gisMapComp && this.gisMapComp.map) {
      this.gisMapComp.map.on('click', () => {
        this.gisMapComp.clearMarker();
      });
    }
  }

  onSearch(event: any) {
    const value = event.target.value;

    if (!value || value.trim().length === 0) {
      this.searchControl.setValue('', { emitEvent: false });
      this.sessionToken = null;
      this.suggestions = [];
      if (this.gisMapComp) { this.gisMapComp.clearMarker(); }
      this.searchCleared.emit();
      return;
    }
    if (value.length < 2) {
      this.suggestions = [];
      return;
    }

    if (!this.sessionToken) {
      this.sessionToken = uuid.v4();
    }

    this.searchSubject.next(value);
  }

  callAutocompleteAPI(searchText: string) {
    this.utilsService.autocomplete(searchText, this.sessionToken!)
      .subscribe((res: any) => {
        this.suggestions = res.suggestions || [];
      });
  }

  selectPlace(item: any) {
    const placeId = item.placePrediction.placeId;
    const placeName = item.placePrediction.text.text;
    this.searchControl.setValue(placeName, { emitEvent: false });
    this.suggestions = [];

    this.utilsService.getPlaceDetails(placeId, this.sessionToken!)
      .subscribe((res: any) => {
        const latitude = res.location.latitude;
        const longitude = res.location.longitude;

        // Emit to parent component
        if (this.gisMapComp) {
          this.gisMapComp.map.flyTo([latitude, longitude], 12, { duration: 1.5 });
          this.gisMapComp.addMarker(latitude, longitude);
        }
        this.utilsService.getFeatureByPoint(latitude, longitude, 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED')
          .subscribe((geoRes: any) => {
            // console.log(geoRes);
            const feature = geoRes.features[0];
            if (feature) {
              const properties = feature.properties;
              const blockName = properties['block_name'];
              const dist_Name = properties['dist_name'];
              const districtUUID = properties['dist_uuid'];
              const stateName = properties['state_name'].toLowerCase().replace(/\b\w/g, c => c.toUpperCase());;
              const stateUUID = properties['state_uuid'];
              let options: any = this.gisMapComp ? { ...this.gisMapComp.params } : {};
              options['locName'] = dist_Name;
              options['locType'] = 'DISTRICT';
              options['pUUID'] = districtUUID;
              options['location'] = 'India##00cb31c7-2928-4e6d-adcc-443d478c90d6' + '&' + [stateName, stateUUID].join('##') + '&' + [dist_Name, districtUUID].join('##');
              // this.gisMapComp.router.navigate(['.'], {
              //   relativeTo: this.gisMapComp.route,
              //   queryParams: options,
              //   queryParamsHandling: 'merge',
              // })
              // sessionStorage.setItem('params', options)
              if (this.gisMapComp) {
                this.utilsService.setSelectedParams(options)
                this.syncHeatwaveLayerAfterSearch();
              }
              this.locationSelected.emit({
                ...options,
                latitude,
                longitude,
                blockName,
                stateUUID,
                stateName,
                distUUID: districtUUID,
                distName: dist_Name
              });
            }
          })
      });

    this.sessionToken = null;
  }

  addMarker(lat: number, lon: number) {
    if (this.marker) {
      this.gisMapComp.map.removeLayer(this.marker);
    }
    const customIcon = L.icon({
      iconUrl: 'assets/imgs/google-maps.png',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });
    this.marker = L.marker([lat, lon], { icon: customIcon, pane: 'measuretool' })
      .addTo(this.gisMapComp.map)
    // .bindPopup(`Lat: ${lat}, Lng: ${lon}`)
    // .openPopup();
    this.gisMapComp.map.setView([lat, lon], 14);
  }
  clearMarker() {
    if (this.marker) {
      this.gisMapComp.map.removeLayer(this.marker);
      this.marker = null;
    }
  }
  clearSearch() {
    this.searchControl.setValue('');
    this.suggestions = [];
    if (this.gisMapComp) { this.gisMapComp.clearMarker(); }
    this.searchCleared.emit();
  }

  syncHeatwaveLayerAfterSearch() {
    // if (!this.gisMapComp || this.gisMapComp.componentType !== 'heatwave' && 'heatindex') {
    //   return;
    // }

    const applySelectedTimeline = () => {
      const blockIndex = this.gisMapComp.blockNumber;
      const labels = Array.isArray(this.gisMapComp.labelStrings) ? this.gisMapComp.labelStrings : [];
      if (typeof blockIndex !== 'number' || !labels[blockIndex] || typeof this.gisMapComp.changeTimeLayers !== 'function') {
        return;
      }

      this.gisMapComp.changeTimeLayers(labels[blockIndex].groupName);
    };

    setTimeout(applySelectedTimeline, 300);
    setTimeout(applySelectedTimeline, 800);
  }
}
